import React, { Component } from "react";

import CategoriesEditFunction from "./categoriesEditFunction";
import { withFirebase } from "../../../Firebase";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import withAuthorization from "../../../Session/withAuthorization";

import Navigation from "../../../Navigation";

const CategoriesEditPage = () => {
  return <Navigation content={<CategoriesEditForm />} />;
};

class CategoriesEditPageBase extends Component {
  render() {
    return (
      <>
        <CategoriesEditFunction props={this.props} />
        <label
          style={{
            display: "block",
            marginBottom: "auto",
            textAlign: "center",
            fontSize: 12,
          }}
        >
          Copyright &copy; {new Date().getFullYear()} RAMPVER. All rights
          reserved.
        </label>
      </>
    );
  }
}

const condition = (authUser) => !!authUser;

const CategoriesEditForm = compose(
  withAuthorization(condition),
  withRouter,
  withFirebase
)(CategoriesEditPageBase);

export default CategoriesEditPage;

export { CategoriesEditForm };
